import { z } from 'zod'

export const reorderCategoriesSchema = z.object({
  ids: z.array(z.string().guid()).min(1),
})

export type ReorderCategoriesDto = z.infer<typeof reorderCategoriesSchema>
